import React from 'react';
import { useTheme } from 'styled-components';
import { toast } from 'react-toastify';
import { Poppins } from 'src/common';
import * as S from './ErrorToast.styles';

const ErrorIcon: React.FC<{ className?: string }> = ({ className }) => {
  const colors = useTheme().colors;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none" className={className}>
      <rect
        x="0.807692"
        y="0.807692"
        width="19.3846"
        height="19.3846"
        rx="9.69231"
        fill={colors.error}
        stroke={colors.error}
        strokeWidth="1.61538"
      />
      <path d="M7 7L14 14M14 7L7 14" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

const DEFAULT_MESSAGE = 'Something went wrong';

interface ErrorToastProps {
  message?: string;
}

const ErrorToastContent: React.FC<ErrorToastProps> = ({ message }) => {
  return (
    <S.Div>
      <S.IconWrap>
        <ErrorIcon />
      </S.IconWrap>
      <Poppins weight={600}>{message || DEFAULT_MESSAGE}</Poppins>
    </S.Div>
  );
};

export const showErrorToast = (message?: string) => {
  toast(<ErrorToastContent message={message} />, {
    type: 'error',
    icon: false,
  });
};
